import React from "react";

const INNER_FOCUSABLE_SELECTOR = [
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  '[role="checkbox"]',
  '[role="radio"]',
  "iframe",
].join(",");

export const RequiredMark = () => (
  <span className="required-mark" aria-hidden="true">
    *
  </span>
);

export const getRegistrationFieldA11yProps = (
  field,
  { invalid = false, required = false, describedBy } = {}
) => ({
  "aria-required": required ? true : undefined,
  "aria-invalid": invalid ? true : undefined,
  "aria-describedby":
    describedBy ?? (invalid ? `${field}-error` : undefined),
});

export const focusFirstInvalidRegistrationField = (root) => {
  if (typeof document === "undefined") {
    return false;
  }

  const container = root instanceof HTMLElement ? root : document;
  const invalidNodes = container.querySelectorAll('[aria-invalid="true"]');

  for (const node of invalidNodes) {
    if (!(node instanceof HTMLElement)) {
      continue;
    }

    const tag = node.tagName;
    const role = node.getAttribute("role");
    const isGroup = role === "group" || role === "radiogroup";
    const isNativeControl =
      tag === "INPUT" ||
      tag === "SELECT" ||
      tag === "TEXTAREA" ||
      tag === "BUTTON";

    let target = node;
    if (isGroup) {
      target = node;
    } else if (!isNativeControl) {
      const inner = node.querySelector(INNER_FOCUSABLE_SELECTOR);
      if (inner instanceof HTMLElement) {
        target = inner;
      }
    }

    if (
      target.hasAttribute("disabled") ||
      target.getAttribute("aria-hidden") === "true"
    ) {
      continue;
    }

    target.focus();
    if (typeof target.scrollIntoView === "function") {
      target.scrollIntoView({ block: "center", behavior: "smooth" });
    }
    return true;
  }

  return false;
};

export const scheduleFocusFirstInvalidRegistrationField = (root) => {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      focusFirstInvalidRegistrationField(root);
    });
  });
};
